'use strict';
import * as angular from 'angular';

export default angular.module('wmView', [])
  .directive('wmView', function($compile) {
    return {
      template: require('./wmView.directive.html').default,
      restrict: 'EA',
      scope: {
        application: '=',
        ngModel: '=',
        container: '=',
        windowModels: '=',
        desktopElement: '=',
        controller: '=',
        maximize: '@',
      },

      compile: function(tElement, tAttrs, transclude){
        return{
          pre: function preLink(scope, iElement, iAttrs, controller){
            console.log("wmview:preLink");
          },
          post: function postLink(scope:any, iElement, iAttrs, controller){
            console.log("wmview:postLink");
            const contents = `<${scope.application}-view ng-model="ngModel" container="container" controller="controller" desktop-element="desktopElement" maximize="maximize" class="application-view"></${scope.application}view>`;
            const compiledContents = $compile(contents);

            let eventQueue:string[] = [];
            let flagContentsLinked = false;

            scope.$on('focus', function(){
              console.log('wmView:on:focus');
              if(!flagContentsLinked){
                eventQueue.push('focus');
              }
            });
            compiledContents(scope, function(clonedElement, contentsScope){
              console.log("compiledContents callback");
              iElement.append(clonedElement);

              eventQueue.forEach(function(event){
                console.log('sending event:', event);
                contentsScope.$broadcast(event);
              });
            });
          },
        };
      },
    };
  }).name;
